import React from 'react';
import './BuiltForSection.css';

const BuiltForSection = () => {
  const userAvatars = [
    {
      title: 'Local Stores',
      description: 'Sell products online and in-store with unified inventory management',
      icon: 'fas fa-store'
    },
    {
      title: 'Clinics & Hospitals',
      description: 'Accept appointments, manage patients, and send reminders automatically',
      icon: 'fas fa-clinic-medical'
    },
    {
      title: 'Restaurants',
      description: 'Take online orders, manage deliveries, and track kitchen orders',
      icon: 'fas fa-utensils'
    },
    {
      title: 'Online Brands',
      description: 'Launch stunning e-commerce sites with built-in marketing tools',
      icon: 'fas fa-laptop-code'
    }
  ];

  return (
    <section className="built-for-section">
      <div className="container">
        <h2 className="section-title">Built for</h2>
        <p className="section-subtitle">SMEs who need professional websites without the tech headaches</p>
        <div className="avatars-grid">
          {userAvatars.map((avatar, index) => (
            <div key={index} className="avatar-card">
              <div className="avatar-icon">
                <i className={avatar.icon}></i>
              </div>
              <h3 className="avatar-title">{avatar.title}</h3>
              <p className="avatar-description">{avatar.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BuiltForSection;